<template>
  <b-modal v-model="status"
           :close-title="resource['label.Close']"
           :no-close-on-esc="true"
           :no-close-on-backdrop="true"
           :hide-header-close="true"
           :centered="true"
           body-class="p-0 overflow-unset"
           :hide-header="true"
           title-tag="h2"
           @hidden="hidden"
  >
    <v-touch @swipeleft="swipeRight"
             @swiperight="swipeLeft"
    >
      <div class="position-relative">
        <div>
          <div class="dots">
            <div v-for="(count,index) in list.length"
                 :key="index"
                 :class="{'active':index==currentIndex}"
                 class="dot"
                 @click="currentIndex=index"
            />
          </div>
        </div>
        <div>
          <transition name="slide">
            <img :key="currentIndex"
                 v-bind="img"
                 :src="require(`@/assets/WhatsNews/${list[currentIndex].id}.jpg`)"
                 alt=""
            >
          </transition>
        </div>
      </div>
      <div>
        <transition name="slide">
          <div :key="currentIndex"
               class="content"
          >
            <h2 class="mb-2">
              {{ contents[currentLang][list[currentIndex].id].header }}
            </h2>
            <span class="md"
                  v-html="contents[currentLang][list[currentIndex].id].text"
            />
          </div>
        </transition>
      </div>
    </v-touch>
    <div slot="modal-footer"
         class="w-100 d-flex justify-content-between"
    >
      <button :class="{'disabled pointer-none':currentIndex==0}"
              class="btn md border-dusk text-color-dusk"
              @click="currentIndex--"
      >
        {{ resource['label.Prev'] }}
      </button>
      <button v-if="currentIndex!=(list.length -1)"
              class="btn md bg-dusk text-white"
              @click="++currentIndex"
      >
        {{ resource['label.Next'] }}
      </button>
      <button v-if="currentIndex==(list.length-1)"
              class="btn md border-dusk text-color-dusk"
              @click="status=false"
      >
        {{ resource['label.Close'] }}
      </button>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'WhatsNews',
  data() {
    return {
      status: false,
      img: {
        height: 316,
        class: 'list-img',
      },
      currentIndex: 0,
      contents: {
        'en-US': {
          1: {
            header: 'HR Check-Up Screens Are Now Live!',
            text:
              'Introducing the new HR Check-Up screens, designed by Kariyer.net in cooperation with Turboard company. Users can now access data about their job posts and candidates. NOTICE: For the time being, HR Check-Up screens are only available for Admin users. Soon the screens will be available for all types of users.',
          },
          2: {
            header: 'Contents of The HR Check-Up Screens',
            text:
              '<li>Which steps do the candidates take to find you?</li>'
              + '<li>How many of the candidates that see your job posts, actually apply to it?</li>'
              + '<li>How many of the candidates are reviewed by your employees?</li>',
          },
          3: {
            header: 'It is now so much easier to see the statistics!',
            text:
              "The data previously listed under 'Applications>Statistics' page are now moved to the new screen:"
              + '<li>The ratio of replies vs. applications</li><li>Awaiting applicants</li><li>Average time for replying the applicants</li>',
          },
          4: {
            header: 'See the individual performances of your job posts',
            text:
              'You may now see the individual and total performances of your job posts on the HR Check-Up screens.',
          },
          5: {
            header: 'All Filters at One Place!',
            text:
              'In this new design, you are now able to find all the filters at one place.',
          },
        },
        'tr-TR': {
          1: {
            header: 'HR Check-Up yayında!',
            text:
              'Kariyer.net ve Turboard iş birliği ile oluşturulan HR Check-Up yayında! Artık ilanlarınız ve adaylar hakkındaki verilere bu ekrandan erişebilirsiniz. <br/> NOT: Şimdilik yalnızca Admin kullanıcılar tarafından erişilebilecektir. Yakında tüm kullanıcıların erişimine sunulacaktır.',
          },
          2: {
            header: "HR Check-Up'ta hangi veriler yer alıyor?",
            text:
              '<li>Adaylar size hangi kanaldan ulaşıyor?</li>'
              + '<li>İlanınızı görüntüleyen adayların ne kadarı ilanınıza başvuruyor?</li>'
              + '<li>Başvuru yapan adayların incelenme durumu nedir?</li>',
          },
          3: {
            header: 'İstatistiklere erişim artık daha kolay!',
            text:
              "Daha önce 'Başvurular> İstatistikler' sayfasında yer alan veriler de bu ekrana taşındı:"
              + '<li>Başvuru cevaplama oranı</li><li>Cevap bekleyen aday sayısı</li><li>Ortalama aday cevaplama süresi</li>',
          },
          4: {
            header: 'İlan performanslarını tekil olarak takip edin!',
            text:
              "Kariyer.net'teki ilanlarınızın tekil ve toplu performanslarını da bu ekrandan takip edebilirsiniz.",
          },
          5: {
            header: 'Tüm Filtreler Bir Arada!',
            text: 'Yeni tasarımda tüm filtreler bir araya toplandı.',
          },
        },
      },
      list: [{ id: 5 }],
      advanceListItems: [],
      proListItems: [],
      reportListItem: [
        {
          id: 1,
        },
        {
          id: 2,
        },
        {
          id: 3,
        },
        {
          id: 4,
        },
      ],
    };
  },
  mounted() {
    // Pro
    if (this.currentUser.segmentId === 2) this.list.push(...this.proListItems);

    // Advance
    if (this.currentUser.segmentId === 3) this.list.push(...this.advanceListItems);

    // Turboard
    if (!this.currentUser.nonAuthorizedPermissions.includes('report.view')) this.list.push(...this.reportListItem);
  },
  methods: {
    open() {
      this.status = true;
    },
    swipeRight() {
      if (this.currentIndex < this.list.length - 1) this.currentIndex += 1;
    },
    swipeLeft() {
      if (this.currentIndex !== 0) this.currentIndex -= 1;
    },
    hidden() {
      localStorage.setItem('whatsNewsStatus18October', true);
      this.currentIndex = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.modal-footer {
  border-top: none;
}
.modal-dialog {
  height: 50%;

  @include media-breakpoint-down(md) {
    width: 560px !important;
    min-width: 560px;
    height: auto;
  }
}
img {
  height: auto;
  min-height: 200px;
  @include media-breakpoint-down(md) {
    height: 316px;
  }
}
.modal-content {
  border: none;
}
.header {
  position: absolute;
  color: white;
  top: -60px;
  width: 100%;
  text-align: center;
}
.navigate-icons {
  display: flex;
  justify-content: space-between;
  position: absolute;
  align-items: center;
  height: 100%;
  width: 100%;
  left: 0px;
  z-index: 99;
  @include media-breakpoint-down(md) {
    width: calc(100% + 100px);
    left: -(100px/2);
  }
  i {
    font-size: 32px;
    color: white;
    cursor: pointer;
    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }
  }
}
.content {
  height: 100%;
  margin: 32px;
}
.custom-close {
  font-size: 24px;
  position: absolute;
  right: 16px;
  z-index: 100;
  top: 16px;
  cursor: pointer;
  i {
    z-index: 9;
    color: white;
  }
}
.dots {
  width: 100%;
  z-index: 99;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  position: absolute;
  bottom: 0px;
  text-align: center;
  height: 90px;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  .dot {
    margin-right: 10px;
    margin-bottom: 8px;
    &:last-child {
      margin-right: 0px;
    }
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.4);
    &.active {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }
}
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  display: none;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.list-img {
  border-radius: 4px 4px 0px 0px;
  width: 100%;
}
</style>
